<template>
  <div class="side-bar" :class="{ 'side-bar--active': menuActive }">
    <div class="side-bar__branding">
      <img
        class="side-bar__disc"
        src="/assets/tubechopper_disc.png"
        alt="TubeChopper disc"
      />
      <svgicon
        @click="toggleMenu()"
        class="side-bar__close"
        icon="x-square"
        width="22"
        height="18"
        color="#000"
      >
      </svgicon>
    </div>
    <ul class="side-nav side-bar__nav">
      <li class="side-bar__nav-item">
        <router-link to="/">Home</router-link>
      </li>
      <li class="side-bar__nav-item">
        <router-link to="/manual">Manual</router-link>
      </li>
      <li class="side-bar__nav-item">
        <router-link to="/changelog">Changelog</router-link>
      </li>
    </ul>
    <h3>MIDI config</h3>
    <div class="column midi">
      <div v-if="hasMidi" class="midi-select">
        <div v-if="midiInputs.length" class="midi-select">
          <label class="midi-select__label" for="currentInput">
            Select MIDI device:
          </label>
          <select class="midi-select__select" v-model="currentInput">
            <option v-for="midiInput in midiInputs" v-bind:key="midiInput.id">
              {{ midiInput.name }}
            </option>
          </select>
        </div>
        <div v-else class="no-midi midi-select__input--empty">
          No MIDI inputs found!
        </div>
      </div>
      <div v-else class="no-midi">
        Sorry, no MIDI support in this browser!
      </div>
    </div>
    <h3>Memory</h3>
    <div class="side-bar__memory">
      <Memory />
    </div>
    <Attribution />
  </div>
</template>

<script>
import "@/compiled-icons/x-square";
import WebMidi from "webmidi"; // Necessary for MIDI control
import EventBus from "../eventBus"; // We are using EventBus to control the YouTube player on a component level
import Memory from "@/components/Memory.vue";
import Attribution from "@/components/Attribution.vue";

export default {
  name: "SideBar",
  components: {
    Memory,
    Attribution
  },
  data() {
    return {
      midiInputs: [],
      hasMidi: false
    };
  },
  computed: {
    currentInput: {
      get: function() {
        return this.$store.state.volatile.currentMidiInput;
      },
      set: function(value) {
        this.setMidi(value);
      }
    },
    menuActive() {
      return this.$store.state.config.menuActive;
    }
  },
  methods: {
    toggleMenu() {
      this.$store.commit("toggleMenu");
    },
    getMidi() {
      return new Promise((resolve, reject) => {
        /* WebMidi */
        const vm = this;
        WebMidi.enable(function(err) {
          if (err) {
            reject("WebMidi could not be enabled. ", err);
          } else {
            // Viewing available inputs and outputs
            console.log(WebMidi.inputs);
            console.log(WebMidi.outputs);
            vm.midiInputs = WebMidi.inputs.map(midiDevice => ({
              name: midiDevice.name,
              id: midiDevice.id
            }));
            resolve();
          }
        });
      });
    },
    setMidi(value) {
      this.$store.commit("setCurrentMidiInput", value);
      const WebMidiInput = WebMidi.getInputByName(value); // get the right WebMidi input object
      WebMidiInput.addListener("noteon", "all", e => {
        this.$store.commit("setNote", e.note.name);
        EventBus.$emit("YT_TRIG", e.note.name); // Emit timeline event to YouTubePlayer component
      });
      WebMidiInput.addListener("start", "all", () => {
        EventBus.$emit("YT_PLAY"); // Emit event to start the YouTube player
      });
      WebMidiInput.addListener("stop", "all", () => {
        EventBus.$emit("YT_STOP"); // Emit event to stop the YouTube player
      });
    },
    checkAvailableMidi() {
      return this.midiInputs.some(item => {
        console.log(this.$store.state.volatile.currentMidiInput);
        return item.name == this.$store.state.volatile.currentMidiInput;
      });
    }
  },
  mounted() {
    // Enable WebMidi and populate select box with available MIDI inputs
    this.getMidi()
      .then(() => {
        // Set last used MIDI input when available
        if (!this.currentInput == "" && this.checkAvailableMidi()) {
          setTimeout(() => {
            this.setMidi(this.$store.state.volatile.currentMidiInput);
          }, 500);
        }
      })
      .catch(error => {
        console.error("No MIDI today folks :(", error);
      });
    // Check if Browser supports MIDI
    if (navigator.requestMIDIAccess) {
      console.log("This browser supports WebMIDI!");
      this.hasMidi = true;
    } else {
      console.log("WebMIDI is not supported in this browser.");
      this.hasMidi = false;
    }
  },
  beforeDestroy() {
    if (!WebMidi === null) {
      WebMidi = null;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../partials/vars";

a {
  color: #fff;
  text-decoration: none;
  &:hover {
    color: $color-base;
    text-decoration: none;
  }
}

.side-bar {
  min-height: 100%;
  position: absolute;
  text-align: center;
  padding-right: 50px;
  left: 0;
  width: 350px;
  height: 100%;
  background-color: $color-gray-dd;
  z-index: 10;
  transition-property: all;
  transition-duration: 0.5s;
  transition: all 0.35s ease-out; // custom easing
  transform: translateX(-350px);

  h3 {
    color: $color;
    margin-bottom: 0;
  }

  &--active {
    transform: translateX(0);
    padding-right: 0;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  }

  &__nav {
    padding-left: 0;
    &-item {
      list-style-type: none;

      a {
        display: block;
        &:hover {
          color: #fff;
          background-color: $color-base;
        }
        &.router-link-exact-active {
          background-color: $color-gray-d;
        }
      }
    }
  }

  &__branding {
    width: 100%;
    text-align: center;
    margin-top: 30px;
  }

  &__memory {
    padding: 15px;
  }

  &__disc {
    width: 75px;
  }

  &__close {
    cursor: pointer;
    position: absolute;
    right: 15px;
    top: 17px;
  }
}
.midi-select {
  text-align: left;
  margin: 15px 0;
  &__label {
    padding-left: 15px;
    display: block;
    text-align: left;
  }
  &__select {
    width: 100%;
    padding: 5px 12px;
    font-size: 20px;
    &:focus {
      outline: none;
    }
    @media (max-width: $break-small) {
      width: 100%;
    }
  }
}
.no-midi {
  text-align: center;
  padding: 20px;
  background-color: $color-atention;
}
</style>
